/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type SessionPolicies = {
  maxSessionDuration: bigint;
  idleTimeout: bigint;
  concurrentSessions: number;
};

export type SessionPoliciesArgs = {
  maxSessionDuration: number | bigint;
  idleTimeout: number | bigint;
  concurrentSessions: number;
};

export function getSessionPoliciesEncoder(): FixedSizeEncoder<SessionPoliciesArgs> {
  return getStructEncoder([
    ["maxSessionDuration", getI64Encoder()],
    ["idleTimeout", getI64Encoder()],
    ["concurrentSessions", getU8Encoder()],
  ]);
}

export function getSessionPoliciesDecoder(): FixedSizeDecoder<SessionPolicies> {
  return getStructDecoder([
    ["maxSessionDuration", getI64Decoder()],
    ["idleTimeout", getI64Decoder()],
    ["concurrentSessions", getU8Decoder()],
  ]);
}

export function getSessionPoliciesCodec(): FixedSizeCodec<
  SessionPoliciesArgs,
  SessionPolicies
> {
  return combineCodec(getSessionPoliciesEncoder(), getSessionPoliciesDecoder());
}
